<p-dialog [(visible)]="newRecord" [breakpoints]="{ '960px': '50vw', '640px': '100vw' }" [style]="{ width: '50vw' }">
	<ng-template pTemplate="header">
		<div class="w-100">
			<div class="d-flex">
				<fa-icon [icon]="['far', 'palette']" class="me-4" size="2x"></fa-icon>
				<div class="display-8 ms-1 my-auto">New Canvas</div>
			</div>
			<p-divider></p-divider>
			<div class="p-grid">
				<div class="p-col-12 p-md-6">
					<span class="p-float-label mt-4">
						<input pInputText #canvasName name="canvasName" type="text" [(ngModel)]="canvas.name" class="w-100" />
						<label for="canvasName">Name</label>
					</span>
				</div>
				<div class="p-col-12 p-md-6">
					<span class="p-float-label mt-4">
						<input pInputText #canvasDisplayName name="canvasDisplayName" type="text" [(ngModel)]="canvas.displayName" class="w-100" />
						<label for="canvasDisplayName">Display name</label>
					</span>
				</div>
			</div>
			<p-divider>Select canvas type</p-divider>
			<div class="d-flex w-100 justify-content-evenly">
				<p-selectButton [(ngModel)]="newCanvasType" [options]="newCanvasTypeOptions" optionLabel="label" optionValue="value"></p-selectButton>
			</div>
			<div class="d-flex w-100">
				<ng-container *ngIf="newCanvasType === 0"></ng-container>
				<ng-container *ngIf="newCanvasType === 1">
					<div class="p-grid w-100">
						<div class="p-col-12 p-md-6">
							<span class="p-float-label mt-4 w-100">
								<p-dropdown
									#shareFromVenueList
									[options]="userService.userVenues.value"
									optionLabel="venueName"
									optionValue="venueKey"
									name="shareFromVenueList"
									[(ngModel)]="sharedFromVenueKey"
									[style]="{ width: '100%' }"
									appendTo="body"
									[autoDisplayFirst]="false"
									[virtualScroll]="true"
									virtualScrollItemSize="30"
									filter="true"
									filterBy="venueKey,venueName"
									(ngModelChange)="getCanvasForVenues(sharedFromVenueKey)"
								></p-dropdown>
								<label for="shareFromVenueList">Venue to Share From</label>
							</span>
						</div>
						<div class="p-col-12 p-md-6">
							<span class="p-float-label mt-4 w-100">
								<p-dropdown
									#sharedFromCanvasList
									[dropdownIcon]="!selectableCanvases || selectableCanvases?.length === 0 ? 'pi pi-spinner pi-spin' : 'pi pi-chevron-down'"
									[options]="selectableCanvases"
									optionLabel="name"
									optionValue="canvasKey"
									name="sharedFromCanvasList"
									[(ngModel)]="sharedFromCanvasKey"
									[style]="{ width: '100%' }"
									appendTo="body"
									[autoDisplayFirst]="false"
									[virtualScroll]="true"
									virtualScrollItemSize="30"
									filter="true"
									[disabled]="!selectableCanvases || selectableCanvases?.length === 0"
									(filterBy)="app.keys(selectableCanvases)"
								></p-dropdown>
								<label for="sharedFromCanvasList">Canvas</label>
							</span>
						</div>
					</div>
				</ng-container>
				<ng-container *ngIf="newCanvasType === 2">
					<div class="p-grid w-100">
						<div class="p-col-12">
							<span class="p-float-label mt-4">
								<p-dropdown
									#duplicateCanvasList
									[options]="venueService.subscriptionOOcanvas.value"
									optionLabel="name"
									optionValue="canvasKey"
									name="duplicateCanvasList"
									[(ngModel)]="sharedFromCanvasKey"
									[style]="{ width: '100%' }"
									appendTo="body"
									[autoDisplayFirst]="false"
									[virtualScroll]="true"
									virtualScrollItemSize="30"
									filter="true"
									(filterBy)="app.keys(selectableCanvases)"
								></p-dropdown>
								<label for="duplicateCanvasList">Canvas to Duplicate from</label>
							</span>
						</div>
					</div>
				</ng-container>
			</div>
		</div>
	</ng-template>
	<ng-template pTemplate="footer">
		<app-record-control-footer
			[hideAdd]="true"
			[hideCancel]="false"
			[hideDelete]="true"
			[hideSave]="false"
			(onCancelChange)="newRecordChange.emit(false)"
			(onSaveChange)="onSave()"
			[cancelDisabled]=""
			[saveDisabled]="!clearToSave()"
		></app-record-control-footer>
	</ng-template>
</p-dialog>
